import Single from "./_single.es6";
import CharaVoice from './_voice.es6';
import CharaGallery from './_gallery.es6';

const single = new Single();
const voice = new CharaVoice();
const gallery = new CharaGallery();